import React from 'react';
import BoxesColumn from './BoxesColumn';
import { t, props } from 'tcomb-react';

@props({
  advBoxes: t.Arr,
  title: t.Str
})
export default class AdvBoxes extends React.Component {

  hasAdvBoxes() {
    return (this.props.advBoxes && this.props.advBoxes.length !== 0);
  }

  getBoxesInLargeColumn() {
    return this.props.advBoxes.map(function (advBox, index){
      return <BoxesColumn key={'large-' + index} boxes={advBox} width='large-33' />;
    });
  }

  getBoxesInSmallColumn() {
    return this.props.advBoxes.map(function (advBox, index){
      return <BoxesColumn key={'small-' + index} boxes={advBox} width='small-100' />;
    });
  }

  render() {

    if (!this.hasAdvBoxes()) {
      return null;
    }

    return (
      <div className="adv_boxes">
        <h2>{this.props.title}</h2>
        <div className="small-hide">
          <div className="cols">
            { this.getBoxesInLargeColumn() }
          </div>
        </div>
        <div className="large-hide medium-hide small-show">
          <div className="cols">
            { this.getBoxesInSmallColumn() }
          </div>
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/AdvBoxes.js
 **/